<template>
  <div id="home-container">
    <el-container>
      <el-header>
        <myHeader></myHeader>
      </el-header>
      <el-container>
        <el-aside width="210px">
          <leftMenu></leftMenu>
        </el-aside>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import myHeader from './components/header.vue'
import leftMenu from './components/leftMenu.vue'

export default {
  data() {
    return {}
  },
  components: {
    myHeader,
    leftMenu
  }
}
</script>
<style lang='scss'>
html,
body,
#app,
#home-container {
  width: 100%;
  height: 100%;
  //overflow: hidden;
}
#home-container {
  .el-header {
    padding: 0;
  }
  .el-aside {
    z-index: 100;
  }
}

#home-container > .el-container {
  height: 100%;
}
.el-aside {
  border-right: 1px solid #e6e6e6;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
html,
body {
  overflow: hidden;
}
.el-message-box__title {
  font-size: 16px !important;
}
</style>
